/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Pages_Create_Link_TargetInputs */

const en_forms_custom_pages_create_link_target = /** @type {(inputs: Forms_Custom_Pages_Create_Link_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Target`)
};

const de_forms_custom_pages_create_link_target = /** @type {(inputs: Forms_Custom_Pages_Create_Link_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Ziel`)
};

/**
* | output |
* | --- |
* | "Link Target" |
*
* @param {Forms_Custom_Pages_Create_Link_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_pages_create_link_target = /** @type {((inputs?: Forms_Custom_Pages_Create_Link_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Pages_Create_Link_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_pages_create_link_target(inputs)
	return de_forms_custom_pages_create_link_target(inputs)
});